import FractionDsnType from '@/generated/controls/fractionDsn/FractionDsnType.vue';
import Item from '@/framework/base/classes/Item';
import {defineComponent} from "vue";

export default defineComponent({
    components: {},
    extends: FractionDsnType,
    data() {
        const items: Item[] = [
            {"key": 1, "title": "Régime général"},
            {"key": 2, "title": "Intermittents"},
            {"key": 3, "title": "Régime général / intermittents"}
        ];

        return {
            items
        };
    }
})
